"use client"

import type React from "react"
import type { FormEvent } from "react"
import { cn } from "../lib/utils"
import { SendHorizontal } from "./icons"

// Mock UI components
const Button = ({ children, className, onClick, type, size, disabled, ...props }: any) => (
  <button
    className={cn(
      "px-4 py-2 rounded font-medium focus:outline-none",
      size === "icon" && "p-2 aspect-square",
      disabled && "opacity-50 cursor-not-allowed",
      className,
    )}
    onClick={onClick}
    type={type}
    disabled={disabled}
    {...props}
  >
    {children}
  </button>
)

interface ChatInputProps {
  input: string
  handleInputChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void
  handleSubmit: (e: FormEvent<HTMLFormElement>) => void
  isLoading?: boolean
}

export function ChatInput({ input, handleInputChange, handleSubmit, isLoading = false }: ChatInputProps) {
  return (
    <div className="p-4 border-t border-zinc-800 bg-zinc-900/50 backdrop-blur-sm mobile-chat-input">
      <form onSubmit={handleSubmit} className="flex items-end gap-2 max-w-4xl mx-auto">
        <div className="relative flex-1">
          <textarea
            value={input}
            onChange={handleInputChange}
            disabled={isLoading}
            placeholder={isLoading ? "Sending message..." : "Send a message..."}
            className={cn(
              "w-full rounded-lg bg-zinc-800 border border-zinc-700 p-3 pr-12 resize-none min-h-[60px] max-h-[200px] focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent",
              isLoading && "opacity-50 cursor-not-allowed"
            )}
            rows={1}
            onKeyDown={(e) => {
              if (isLoading) return; // Prevent keyboard interactions when loading
              if (e.key === "Enter" && !e.shiftKey) {
                e.preventDefault()
                if (input.trim()) {
                  handleSubmit(e as unknown as FormEvent<HTMLFormElement>)
                }
              }
            }}
            style={{
              height: "60px",
              overflowY: "auto",
            }}
          />
          <Button
            type="submit"
            size="icon"
            className="absolute right-2 top-1/2 -translate-y-1/2 bg-emerald-600 hover:bg-emerald-700 text-white rounded-full h-8 w-8"
            disabled={!input.trim() || isLoading}
          >
            {isLoading ? (
              <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
            ) : (
              <SendHorizontal />
            )}
          </Button>
        </div>
      </form>
    </div>
  )
}
